import { render } from "./pcDeptSelect.vue?vue&type=template&id=42ca6f90&scoped=true"
import script from "./pcDeptSelect.vue?vue&type=script&lang=js"
export * from "./pcDeptSelect.vue?vue&type=script&lang=js"

import "./pcDeptSelect.vue?vue&type=style&index=0&id=42ca6f90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ca6f90"]])

export default __exports__